export interface VtexSimulationShippingResponseFullModel {
  errorMessage?: string;
  freightSimulated?: VtexSimulationShippingFreightSimulated[];
  endereco?: VtexSimulationShippingAddress;
  freightOverPrice?: number;
  debug?: any;
  carriersNotChosenList?: any[];
  genericReasons?: VtexSimulationShippingGenericReasons[];
}

export interface VtexSimulationShippingFreightSimulated {
  items?: VtexSimulationShippingItems[];
  slaResponseFreightSimulated?: VtexSimulationShippingSlaResponseModel[];
}

export interface VtexSimulationShippingSlaResponseModel {
  wareHouseId: string;
  wareHouseName: string;
  dockId: string;
  dockName: string;
  zipCodeStart: string;
  zipCodeEnd: string;
  weightStart: number;
  weightEnd: number;
  absoluteMoneyCost: number;
  availabilityQuantity: number;
  salesChannel: string;
  slaType: string;
  slaTypeName: string;
  freightTableId: string;
  freightTableName: string;
  listPrice: number;
  transitTime: string;
  dockTime: string;
  totalTime: string;
  estimateDate: string;
}

export interface VtexSimulationShippingItems {
  nome?: string;
  status?: boolean;
  productname?: string;
  skuname?: string;
  id?: string;
  groupItemId?: any;
  quantity?: number;
  price?: number;
  modal?: string;
  additionalHandlingTime?: string;
  dimension?: VtexSimulationShippingDimension;
  kitItem?: any[];
  unlimitedQuantity?: boolean;
  dockId?: any;
  warehouseId?: any;
  provider?: any;
}

export interface VtexSimulationShippingDimension {
  weight?: number;
  height?: number;
  width?: number;
  length?: number;
  maxSumDimension?: number;
}

export interface VtexSimulationShippingAddress {
  postalCode?: string;
  city?: string;
  state?: string;
  stateAcronym?: string;
  neighborhood?: string;
  streetType?: string;
  street?: string;
  streetAbbreviation?: string;
  number?: string;
  complement?: string;
  country?: VtexSimulationShippingCountry;
  latitude?: any;
  longitude?: any;
  location?: VtexSimulationShippingLocation;
}

export interface VtexSimulationShippingCountry {
  id?: string;
  name?: string;
  specificData?: { [key: string]: any };
}

export interface VtexSimulationShippingLocation {
  lat?: number;
  lng?: number;
}

export interface VtexSimulationShippingGenericReasons {
  Key?: number;
  Value?: string;
}

export const SIMULATE_GENERIC_MESSAGE_ERRORS: Record<number, { title: string, message: string, link?: string }> = {
  1: {
    title: "Atenção ao estoque.",
    message: "Os seguintes itens estão sem estoque para entrega (clique no item para gerenciar o estoque):",
    link: "https://{accountName}.myvtex.com/admin/logistics/#/warehouse-update/skuId/{skuId}"
  },
  2: {
    title: "Atenção ao modal.",
    message: "O modal configurado para o produto não é suportado pelas transportadoras.",
    link: "https://help.vtex.com/pt/tutorial/como-funciona-o-modal"
  },
  4: {
    title: "Atenção ao modal.",
    message: "Não há transportadoras para um produto sem modal definido.",
    link: "https://help.vtex.com/pt/tutorial/como-funciona-o-modal"
  }
}

export function getSimulationGenericMessage(accountName: string, id: number, sku: string) {
  const tmp = SIMULATE_GENERIC_MESSAGE_ERRORS[id];
  if (tmp) {
    return {
      title: tmp.title.replace(/{skuId}/g, String(sku)).replace(/{accountName}/g, accountName.toLowerCase()),
      message: tmp.message.replace(/{skuId}/g, String(sku)).replace(/{accountName}/g, accountName.toLowerCase()),
      link: tmp.link?.replace(/{skuId}/g, String(sku)).replace(/{accountName}/g, accountName.toLowerCase())
    };
  }
  return {
    title: "Erro desconhecido",
    message: "Ocorreu um erro desconhecido ao simular a entrega. Por favor, tente novamente mais tarde."
  };
}
